import MarketingPreferencesInfoContent from './MarketingPreferencesInfoContent';

export default MarketingPreferencesInfoContent;
